var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons';
import SearchSelect from '../SearchSelect';
import { Container } from './styles';
var AdvancedSearch = function (_a) {
    var _setValue = _a.setValue, _value = _a.value, error = _a.error, callback = _a.callback, noResults = _a.noResults, loading = _a.loading, fields = _a.fields, rest = __rest(_a, ["setValue", "value", "error", "callback", "noResults", "loading", "fields"]);
    var _b = useState(''), value = _b[0], setValue = _b[1];
    var callbackHandler = useCallback(function (value) {
        if (callback) {
            callback(value);
        }
    }, [callback]);
    var onChange = useCallback(function (_, a) {
        if (_setValue) {
            _setValue(function (oldSearches) {
                if (a === null || a === void 0 ? void 0 : a.option) {
                    oldSearches[a.option.fieldName] = a.option.fieldValue;
                }
                else if (a === null || a === void 0 ? void 0 : a.removedValue) {
                    delete oldSearches[a.removedValue.fieldName];
                }
                setTimeout(function () {
                    var _a;
                    (_a = document
                        .querySelector('.react-select__value-container')) === null || _a === void 0 ? void 0 : _a.scrollTo(10000, 0);
                }, 0);
                callbackHandler(oldSearches);
                return oldSearches;
            });
        }
    }, [value]);
    var onInputChange = useCallback(function (e) {
        setValue(e);
    }, []);
    var fieldsOptions = fields === null || fields === void 0 ? void 0 : fields.map(function (i) { return ({
        label: i.label,
        value: i.value,
        fieldName: i.value,
        fieldValue: value,
    }); });
    return (React.createElement(Container, __assign({ noResults: noResults }, rest),
        React.createElement(SearchSelect, { id: "alecrim", async: false, isMulti: true, isSearch: true, name: "search", autoFocus: true, loadOptions: fieldsOptions, value: value, onChange: onChange, onInputChange: onInputChange, getOptionLabel: function (option) {
                return "".concat(option.label, " cont\u00E9m: ").concat(option.fieldValue);
            }, isOptionDisabled: function (e) { var _a; return ((_a = e === null || e === void 0 ? void 0 : e.fieldValue) === null || _a === void 0 ? void 0 : _a.length) <= 0; }, error: error, placeholder: "Digite um termo", defaultValue: Object.keys(_value).map(function (i) {
                return _value[i] &&
                    fields.find(function (f) { return f.value === i; }) && {
                    label: fields.find(function (f) { return f.value === i; }).label,
                    value: i,
                    fieldName: i,
                    fieldValue: _value[i],
                };
            }) }),
        React.createElement(FontAwesomeIcon, { style: {
                position: 'absolute',
                top: '50%',
                left: 10,
                transform: 'translateY(-50%)',
                zIndex: 999999,
            }, icon: loading ? faSpinner : faSearch, spin: loading, onClick: callbackHandler }),
        React.createElement("span", null, error && 'Sua busca não foi encontrada')));
};
export default AdvancedSearch;
